const plugins: Record<string, () => Promise<unknown>> = {
  coverage: () => import(/* webpackChunkName: "coverage" */ './coverage/src'),
  guides: () => import(/* webpackChunkName: "guides" */ './guides/src'),
  support: () => import(/* webpackChunkName: "support" */ './support/src'),
}
export default plugins
